import * as React from 'react';
import { MeatballMenu } from 'ui';
import { SearchButton } from 'app/area/indicator-factors/list/search-button';
import { ToolbarActionsProps } from 'app/area/indicator-factors/list/types-store';
import styles from './toolbar-actions.scss';

export const ToolbarActions: React.FC<ToolbarActionsProps> =
  ({ codetableId, canCreate, breadcrumbs, fetchingCodetableId, toggleDuplicateRows,
    toggleDeleteRows, numberOfResults, translation }) =>
    <div className={styles.wrapper}>
      <div className={styles.searchButton}>
        <SearchButton
          breadcrumbs={breadcrumbs}
          canCreate={canCreate}
          codetableId={codetableId}
          fetchingCodetableId={fetchingCodetableId}
          translation={translation}
        />
      </div>
      {canCreate && <div className={styles.meatball}>
        <MeatballMenu id={'toolbar-actions-meatballmenu'}>
          <li>
            <button
              type="button"
              className="dropdown-item"
              onClick={toggleDuplicateRows}
              disabled={!numberOfResults}>
              {translation.duplicate_rows_description}
            </button>
          </li>
          <li>
            <button
              type="button"
              className="dropdown-item"
              onClick={toggleDeleteRows}
              disabled={!numberOfResults}>
              {translation.delete_rows_description}
            </button>
          </li>
        </MeatballMenu>
      </div>}
    </div>;
